module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/event/icon-665b8c43d3a0107da9b7e24772f6cbc9.svg";